import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SNACK_LIST_FOR_DESIGN_PLAIN_QUERY } from "./schema";

export const useSnackListQuery = (hotelID: string) => {
	const { data, refetch } = useCustomSuspenseQuery(SNACK_LIST_FOR_DESIGN_PLAIN_QUERY, { variables: { hotelID } });

	return {
		data,
		refetch,
	};
};
